import { Toast } from 'vant'
import regex from '@/configs/regex.js'

export default {
    name: 'LoginPage',
    data() {
        return {
            mobile: '',
            code: '',
            timer: null,
            loading: false,
            interval: 0,
            agreement: false,
            aliParam: '', // 阿里云验证码2.0参数
            sceneId: 'zsiftxi3', // 场景ID
            captcha: null, // 验证码实例
        }
    },
    computed: {
        // 能否获取验证码
        canGetCode() {
            return this.mobile && regex.mobile.test(this.mobile) && this.aliParam
        }
    },
    unmounted() {
        // 清理定时器
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initNoCaptcha()
        })
    },
    methods: {
        // 初始化滑动验证
        initNoCaptcha() {
            const _this = this
            
            // 获取容器实际宽度
            const slideBarElement = document.getElementById('slide-bar')
            let containerWidth = 300
            if (slideBarElement && slideBarElement.parentElement) {
                const parentWidth = slideBarElement.parentElement.offsetWidth
                containerWidth = parentWidth > 0 ? parentWidth : 300
            }
            // 确保宽度不超过 300px，与设计保持一致
            const slideWidth = Math.min(containerWidth, 300)
            
            window.initAliyunCaptcha({
                SceneId: _this.sceneId,
                mode: "embed",
                element: "#slide-bar",
                success: function (captchaVerifyParam) {
                    // 确保 captchaVerifyParam 是字符串
                    const param = typeof captchaVerifyParam === 'string' ? captchaVerifyParam : (captchaVerifyParam || '')
                    _this.aliParam = param
                    if (regex.mobile.test(_this.mobile)) {
                        // 直接传递参数，避免响应式更新延迟问题
                        _this.send(param)
                    }
                },
                fail: function () {
                    _this.aliParam = ''
                    Toast('验证失败，请重试')
                },
                error: function () {
                    _this.aliParam = ''
                    Toast('验证码加载异常，请刷新页面重试')
                },
                getInstance: function (instance) {
                    _this.captcha = instance
                },
                // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
                slideStyle: {
                    width: slideWidth,
                    height: 40,
                },
            })
        },
        send(captchaParam) {
            if (this.timer !== null || this.loading) return
            // 优先使用传入的参数，如果没有则使用 this.aliParam
            const param = captchaParam || this.aliParam
            if (!param) {
                Toast('请完成滑动验证')
                return
            }
            if (regex.mobile.test(this.mobile)) {
                this.loading = true
                this.$http.get('sms/login', {
                    params: {
                        mobile: this.mobile,
                        captchaVerifyParam: param,
                        sceneId: this.sceneId
                    }
                }).then(() => {
                    this.interval = 60
                    this.timer = setInterval(() => {
                        if (this.interval === 0) {
                            clearInterval(this.timer)
                            this.timer = null
                        } else {
                            this.interval = --this.interval
                        }
                    }, 1000)
                    Toast('发送成功')
                }).catch(() => {
                    // 验证码发送失败，清空验证参数，让用户重新验证
                    this.aliParam = ''
                }).finally(() => {
                    this.loading = false
                })
            }
        },
        submit() {
            if (!regex.mobile.test(this.mobile)) {
                Toast('请输入正确的手机号')
                return
            }
            if (!this.code) {
                Toast('请输入验证码')
                return
            }
            if (!this.agreement) {
                Toast('请阅读并同意协议')
                return
            }
            if (this.loading) return
            
            this.loading = true
            this.$http.post('login', {
                mobile: this.mobile, 
                code: this.code
            }).then(result => {
                this.$store.commit('setUser', result.data.user)
                this.$store.commit('setAuthorization', result.data.token)
                this.$router.replace(this.$route.query.back ? this.$route.query.back : '/')
            }).finally(() => {
                this.loading = false
            })
        }
    }
}